import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useGuardedNavigation } from '../../../permissions/useGuardedNavigation';

export default function ProductActionMenu({ product }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { navigateDetails, navigateEdit } = useGuardedNavigation('products');

  return (
    <>
      <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={() => navigateDetails(product.stripe_product_id)}>Details</MenuItem>
        <MenuItem onClick={() => navigateEdit(product.stripe_product_id)}>Edit</MenuItem>
      </Menu>
    </>
  );
}
